/* eslint-disable no-restricted-syntax */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PokerGameModel } from 'mvppoker-portal-common/api'

export interface Rooms {
	rooms: PokerGameModel[],
	roomsLookup: { [roomId: string] : PokerGameModel },
	loading: boolean
}

const initialState: Rooms = {
	rooms: [],
	roomsLookup: {},
	loading: false,
}

export const roomsSlice = createSlice({
	name: 'Rooms',
	initialState,
	reducers: {
		updateRooms: (state, action: PayloadAction<PokerGameModel[]>) => 
		{
			state.rooms = action.payload
			const lookup : { [roomId: string] : PokerGameModel } = {}
			for(const r of action.payload){
				lookup[r.id] = r
			}
			state.roomsLookup = lookup
			state.loading = false
		},
		setLoadingRooms: (state, action: PayloadAction<boolean>) =>
		{
			state.loading = action.payload
		},
	},
})

export const { updateRooms, setLoadingRooms } = roomsSlice.actions

export default roomsSlice.reducer
